<div class="auth">
  <div class="auth-complete-sign-in">
    <app-confirm-phone-number [verificationInfo]="[]" (submitVerification)="handleVerificationData($event)">
    </app-confirm-phone-number>

  </div>
</div>